import { Plugins } from '@leverege/plugin';
import { ModelFactory } from '@leverege/ui-plugin';
import { AttributeExportFieldModel } from '@leverege/ui-attributes';
import StringUtil from '@leverege/string-util';
const install = opts => {
  let exportFieldCreatorOnChange = null;
  const dirty = evt => {
    if (exportFieldCreatorOnChange) {
      exportFieldCreatorOnChange();
    }
  };
  Plugins.on('Attribute', dirty);
  Plugins.add('ExportFieldCreator', {
    name: 'ParentRelationshipExportFieldCreator',
    onChange: cb => {
      exportFieldCreatorOnChange = cb;
    },
    create: () => {
      const plgs = Plugins.get('Attribute');
      const fields = [];
      plgs.forEach(attr => {
        const d = attributeToExportField(attr);
        if (d != null) {
          fields.push(d);
        }
      });
      return fields;
    }
  });
  function attributeToExportField(attr) {
    if (attr.valueType === 'parentRelationship') {
      const model = ModelFactory.get(`attr.exportField.${attr.valueType}`) || AttributeExportFieldModel;
      // TODO: check to see if we want to expose this parent
      return {
        name: attr.displayName || StringUtil.camelCaseToTitleCase(attr.name),
        objectType: attr.objectType,
        layout: {
          ...attr.layout
        },
        attrName: attr.name,
        create: () => {
          let mdl = model.create(attr.name, attr.objectType);
          mdl = model.setHeaderLabel(mdl, attr.displayName || StringUtil.camelCaseToTitleCase(attr.name));
          return mdl;
        }
      };
    }
    return null;
  }
};
export default {
  install
};